// Copyright 2026. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { Translate } from '@plesk/ui-library';
import {
    BreadcrumbContainer,
    BreadcrumbSeparator,
    BreadcrumbStep,
} from 'admin/failoverDomain/containers/FailoverDomainCreateDialog/Styles';
import { FAILOVER_DOMAIN } from 'admin/failoverDomain/constants/tests';

export interface IStepBreadcrumbProps {
    currentStep: number;
    selectedCrCount: number;
    selectedIpBlockCount: number;
    onBack: () => void;
}

export const StepBreadcrumb: React.FC<IStepBreadcrumbProps> = ({
    currentStep,
    selectedCrCount,
    selectedIpBlockCount,
    onBack,
}) => {
    const handleCrStepClick = () => {
        if (currentStep === 2) {
            onBack();
        }
    };

    return (
        <BreadcrumbContainer data-cy={FAILOVER_DOMAIN.STEP_BREADCRUMB}>
            <BreadcrumbStep
                isActive={currentStep === 1}
                isClickable={currentStep === 2}
                onClick={handleCrStepClick}
                data-cy={FAILOVER_DOMAIN.STEP_CR}
            >
                <Translate content="failoverDomain.create.steps.computeResources" />
                {` (${selectedCrCount})`}
            </BreadcrumbStep>
            <BreadcrumbSeparator>{'>'}</BreadcrumbSeparator>
            <BreadcrumbStep
                isActive={currentStep === 2}
                isClickable={false}
                data-cy={FAILOVER_DOMAIN.STEP_IP}
            >
                <Translate content="failoverDomain.create.steps.ipBlocks" />
                {` (${selectedIpBlockCount})`}
            </BreadcrumbStep>
        </BreadcrumbContainer>
    );
};

export default StepBreadcrumb;
